(function(){
  $(window).on('load', function() {
    $('.afterSelectSize').addClass('hide');
    $('.selectSizeBtnMain').removeClass('hide');


    $('.selectSizeBtn').on('click', function(e){
      $('.selectSizeErrorMsg').removeClass('hide');
      e.preventDefault();
      return false;
    });
    
    $('.moreProductOption-1').on('click', function(){

      $('.selectSizeErrorMsg').addClass('hide');
      var oprionVal = $(this).val();
      if(oprionVal == "With Stitched Blouse"){
        $('.extraFields').html('<div class="extraFields_select"> <label class="yv-variant-title">Size: </label> <select required class="required extraFieldsSelect" id="select-size" name="properties[Blouse Size]"> <option value="">Select Size</option> <option value="XS">XS</option><option value="S">S</option><option value="M">M</option><option value="L">L</option><option value="XL">XL</option><option value="XXL">XXL</option> </select> </div><div class="selectSizeWithSareeError hide"><label>Please Select Size</label></div>')
        
        $('.moreProductOption-1').removeClass('selectedOPtion');
        $(this).addClass('selectedOPtion');
        $('.selectSizeErrorMsg').addClass('hide');
        $('.selectSizeBtn').addClass('hide');
        $('.afterSelectSize').addClass('hide');
        $('.afterOptionSelect').removeClass('hide');
        $('.extraFields_sizeChart').removeClass('hide');
        
      }else{
        $('.extraFields').html('');
        $('.moreProductOption-1').removeClass('selectedOPtion');
        $(this).addClass('selectedOPtion');
        $('.selectSizeBtn').addClass('hide');
        $('.afterSelectSize').removeClass('hide');
        $('.afterOptionSelect').addClass('hide');
        $('.extraFields_sizeChart').addClass('hide');
      }
    });
    $('.moreProductOption-2').on('click', function(){

        $('.moreProductOption-2').removeClass('selectedOPtion');
        $(this).addClass('selectedOPtion');
    });
    $('.moreProductOption-3').on('click', function(){

        $('.moreProductOption-3').removeClass('selectedOPtion');
        $(this).addClass('selectedOPtion');
    });

    $('.afterOptionSelect').on('click', function(event){
      $('.selectSizeWithSareeError').removeClass('hide');
      event.preventDefault();
      return false;
    });
  
    $('body').on('change', '.extraFieldsSelect', function(){
      var sizeSelectVal = $(this).val();
      $('.selectSizeWithSareeError').addClass('hide');
      if(sizeSelectVal == ''){
        $('.selectSizeBtn').addClass('hide');
        $('.afterSelectSize').addClass('hide');
        $('.afterOptionSelect').removeClass('hide');
      }else{
        $('.selectSizeBtn').addClass('hide');
        $('.afterSelectSize').removeClass('hide');
        $('.afterOptionSelect').addClass('hide');
      }
    });

    $('.sizeChartButton').on('click', function(){
      $('.sizeChartPopupNew').removeClass('hide');
    });
    $('.sizeChartPopupNewClose').on('click', function(){
      $('.sizeChartPopupNew').addClass('hide');
    });
    
    $('body').on('click', '.copy-code', function(){
      var $clickedElement = $(this);
      var $strongElement = $clickedElement.find('strong');
      
      // Check if the clicked element already has the "active" class
      if ($clickedElement.hasClass("active")) {
        // Clicked element already active, remove the class
        $clickedElement.removeClass("active");
      } else {
        // Clicked element not active, add the class and remove from others
        $(".copy-code").removeClass("active");
        $clickedElement.addClass("active");
        
        // Additional actions or modifications
        console.log("Strong element is now active");
        
        // Call the copyToClipboard function passing the 'strong' element
        copyToClipboard($strongElement);
      }
    });

    // size chart popup JS START
    $('body').on('click', '.sizeChartBunaai', function(){
      $('.bunaai_model').removeClass('hide');
    });
      
    $('body').on('click', '.bunaai_close', function(){
      $('.bunaai_model').addClass('hide');
    });

    $('body').on('click', '.sizeChartUrbanstree', function(){
      $('.urbanstree_model').removeClass('hide');
    });
      
    $('body').on('click', '.urbanstree_close', function(){
      $('.urbanstree_model').addClass('hide');
    });

    $('body').on('click', '.sizeChartOrdinaree', function(){
      $('.ordinaree_model').removeClass('hide');
    });
      
    $('body').on('click', '.ordinaree_close', function(){
      $('.ordinaree_model').addClass('hide');
    });

    $('body').on('click', '.sizeChartBunaaiMenKurta', function(){
      $('.bunaai_men_kurta_model').removeClass('hide');
    });
      
    $('body').on('click', '.bunaai_men_kurta_close', function(){
      $('.bunaai_men_kurta_model').addClass('hide');
    });

    $('body').on('click', '.sizeChartBunaaiMenPants', function(){
      $('.bunaai_men_pants_model').removeClass('hide');
    });
      
    $('body').on('click', '.bunaai_men_pants_close', function(){
      $('.bunaai_men_pants_model').addClass('hide');
    });

    $('body').on('click', '.readMoreLess', function(){
      // alert("dots")
      
      var dots = document.getElementById("dots");
      var moreText = document.getElementById("more");
      var btnText = document.getElementById("readMoreLessBtn");
      // alert(dots)
      if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more"; 
        moreText.style.display = "none";
      } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less"; 
        moreText.style.display = "inline";
      }
    });

    // size chart popup JS END

    
  });

  
})();